import React from 'react';

import s from './Divider.scss';
import { Box, Text } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';

export function Divider() {
  const { t } = useTranslation();

  return (
    <Box align="center" verticalAlign="middle" direction="horizontal" gap={2} className={s.dividerSection}>
      <Box className={s.dividerLine} />

      <Text size="small" weight="thin">
        {t('OR').toLowerCase()}
      </Text>

      <Box className={s.dividerLine} />
    </Box>
  );
}
